import { render, staticRenderFns } from "./DataDicManager.vue?vue&type=template&id=339b42be&scoped=true&"
import script from "./DataDicManager.vue?vue&type=script&lang=js&"
export * from "./DataDicManager.vue?vue&type=script&lang=js&"
import style0 from "./DataDicManager.vue?vue&type=style&index=0&id=339b42be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b42be",
  null
  
)

export default component.exports